import { Search, Trash2 } from "../ui/icons";
// import InsertLinkIcon from "../ui/icons";
import { useEffect, useState } from "react";
import { useLayers } from "../../context/LayersContext";
import { mockLayers } from "../../global/constants/layers";
import { Button } from "../ui/buttons/button";
import Typography from "../Typography";
import { Field, FieldGroup } from "../ui/shadcn/forms/field";
import StyledCheckbox from "../ui/styled/styled-checkbox";

type Props = {
  toggleSearch: () => void;
};

export default function LayersFilter({ toggleSearch }: Props) {
  const { layers, addNewLayer, cleanCheckedLayers } = useLayers();
  // const [url, setUrl] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState<string[]>([]);

  const source = "";

  // Layers are now flat with category field, no need to flatten
  const filtered = source
    ? mockLayers.filter((layer) => {
        const matchesTerm = layer.title
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        const matchesSource = layer.source === source;
        return matchesTerm && matchesSource;
      })
    : [];

  const toggleLayer = (title: string) => {
    setSelected((prev) => {
      const isSelected = prev.includes(title);
      const updated = isSelected
        ? prev.filter((l) => l !== title)
        : [...prev, title];

      if (!isSelected) {
        if (!layers.includes(title)) {
          addNewLayer([...layers, title]);
        }
      } else {
        const updatedLayers = layers.filter((l) => l !== title);
        addNewLayer(updatedLayers);
      }

      return updated;
    });
  };

  useEffect(() => {
    setSelected(layers);
  }, [layers]);

  return (
    <>
      <div className="w-full mt-8 mb-1 flex justify-center align-center gap-2 px-1">
        <Button
          variant="outline"
          color="#636467"
          onClick={toggleSearch}
          className="gap-1 mb-2 w-full w-1/2 hover:bg-[#f0f0f0] cursor-pointer text-lg px-3 py-6"
        >
          <Typography variant="body4">Buscar Camada</Typography>
          <Search size={16} />
        </Button>
        <Button
          variant="outline"
          onClick={cleanCheckedLayers}
          className="text-red-400 border-red-400 gap-1 mb-2 w-full w-1/2 hover:bg-[#f0f0f0] hover:text-red-400 cursor-pointer text-lg px-3 py-6"
        >
          <Trash2 color="red" size={16} />
          <Typography variant="body4">Limpar Selecionadas</Typography>
        </Button>
      </div>
      {filtered.length !== 0 && (
        <FieldGroup>
          {filtered.map((layer) => (
            <Field key={layer.title} orientation="horizontal">
              <StyledCheckbox
                checked={selected.includes(layer.title)}
                onCheckedChange={() => toggleLayer(layer.title)}
              />
              <Typography variant="body4">{layer.title}</Typography>
            </Field>
          ))}
        </FieldGroup>
      )}
    </>
  );
}
